
import { defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router';
import {
  retrieveConfigInfo,
} from '@/api/message-center';
import type { IRetrieveConfigInfoRes } from '@/api/message-center/type.d';
import { getLabelByVal } from '@/core/utils/index';
import { CONFIG_IS_ENABLED_LIST } from '@/constant/message-center';

export default defineComponent({
  components: {},
  setup() {
    const $route = useRoute();
    const configId = $route.params.configId as string;

    const configDetail = ref({} as IRetrieveConfigInfoRes);

    const getConfigDetail = async () => {
      const { data } = await retrieveConfigInfo(configId);
      configDetail.value = data;
    };

    const configDetailKeyMap = {
      configCode: {
        label: '配置编码',
      },
      executeService: {
        label: '执行服务',
      },
      sender: {
        label: '发送服务',
      },
      configName: {
        label: '配置名称',
      },
      configType: {
        label: '配置类型',
      },
      exchange: {
        label: 'MQ exchange',
      },
      exchangeType: {
        label: 'MQ exchange 类型',
      },
      queue: {
        label: 'MQ Queue',
      },
      routing: {
        label: 'MQ routing',
      },
      handleType: {
        label: '处理类型',
      },
      hasLock: {
        label: '是否需要加锁',
      },
      maxTryCount: {
        label: '最大重试次数',
      },
      remark: {
        label: '配置备注信息',
      },
      isEnable: {
        label: '是否启用',
        formatter: (value: string) => getLabelByVal(CONFIG_IS_ENABLED_LIST, value),
      },
      consumerBoundUser: {
        label: '消费者负责人名称',
      },
      producerBoundUser: {
        label: '生产者负责人名称',
      },
    };

    const init = () => {
      getConfigDetail();
      console.log('configDetail', configDetail);
    };
    init();
    // window.history.go(-1);

    return {
      configDetail,
      configDetailKeyMap,
    };
  },
});
